<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="560" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-form class="fdlg__form" @submit.prevent="confirmCancel">
        <div class="fdlg__head">
          <div>
            <h2 class="fdlg__title">Anulează demersul</h2>
            <p class="fdlg__sub">Demersurile nu se șterg: rămâne în liste și în istorie cu starea „Anulat”.</p>
          </div>
          <v-btn icon aria-label="Închide" @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text ref="body" class="fdlg__body">
          <section v-if="request" class="form-section">
            <div class="form-section__label"><v-icon small>mdi-file-document-outline</v-icon>Demersul</div>
            <dl class="cancel-facts">
              <dt>Autor</dt>
              <dd>{{ request.user }}</dd>
              <dt>Echipament</dt>
              <dd>{{ [request.equipment, request.model].filter(Boolean).join(" · ") || "—" }}</dd>
              <dt>Cauza</dt>
              <dd>{{ request.cause || "—" }}</dd>
              <dt>Stare</dt>
              <dd><StatusChip :status="request.status" small /></dd>
            </dl>
          </section>

          <section class="form-section">
            <div class="form-section__label"><v-icon small>mdi-message-alert-outline</v-icon>Motivul anulării*</div>
            <p class="form-section__note">Apare în drumul demersului; autorul și aprobatorii îl văd.</p>
            <v-textarea
              v-model="reason"
              placeholder="De ce se anulează demersul"
              outlined
              auto-grow
              rows="3"
              maxlength="2000"
              :error-messages="reasonError"
            ></v-textarea>
            <PhotoInput
              v-model="photos"
              purpose="comment"
              :max="6"
              label="Fotografii (opțional)"
              hint="Opțional; apar în drumul demersului, lângă motiv."
              @uploading="photosUploading = $event"
              @error="$emit('error', $event)"
            />
          </section>
        </v-card-text>

        <div class="fdlg__foot">
          <v-spacer></v-spacer>
          <v-btn text large @click="close()">Înapoi</v-btn>
          <v-btn large depressed color="error" type="submit" :loading="saving" :disabled="photosUploading">
            <v-icon left>mdi-cancel</v-icon>Anulează demersul
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import * as api from "./api";
import * as helper from "@/helper/helper";
import StatusChip from "@/components/elements/StatusChip.vue";
import PhotoInput from "@/components/files/PhotoInput.vue";

// Admin only: requests are never deleted, they are cancelled with a reason
export default {
  components: { StatusChip, PhotoInput },
  data() {
    return {
      dialog: false,
      saving: false,
      request: null,
      reason: "",
      reasonError: "",
      photos: [],
      photosUploading: false,
    };
  },
  watch: {
    reason() {
      this.reasonError = "";
    },
  },
  methods: {
    show(request) {
      this.request = request;
      this.reason = "";
      this.reasonError = "";
      this.photos = [];
      this.dialog = true;
      helper.scrollToTop(this);
    },
    close() {
      this.dialog = false;
    },
    async confirmCancel() {
      if (this.saving || this.photosUploading) return;
      const reason = this.reason.trim();
      if (reason.length < 3) {
        this.reasonError = "Scrieți motivul anulării";
        return;
      }
      this.saving = true;
      try {
        await api.cancelRequest(this.request.id, reason, this.photos.map((photo) => photo.id));
        this.$emit("success", "Demersul a fost anulat");
        this.$emit("updateRequestData", this.request.id);
        this.dialog = false;
      } catch (error) {
        console.error("Error cancelling request:", error);
        this.$emit("error", api.errorMessage(error, "Demersul nu a fost anulat. Încercați din nou."));
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.cancel-facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 6px 16px;
  margin: 0 0 12px;
}
.cancel-facts dt {
  color: var(--ink-3);
  font-weight: 600;
}
.cancel-facts dd {
  margin: 0;
  color: var(--ink);
  word-break: break-word;
}
</style>
